// 로그인 후 모든 화면 위의 macOS 권한 경고 띠(2026-10-12 사용자 지적).
// 종전엔 경고가 "내 기기 정보" 카드(로그인 전 첫 화면 · [연결] 화면)에만 있었다 → 수퍼유저로 자동 로그인하면 [연결] 화면이 없어
// 업데이트로 권한이 초기화돼도(새 ad-hoc 빌드 = 새 앱) 이 Mac 이 원격지원을 못 받는다는 것을 알 길이 없었다.
// 권한을 켜면 `rs-perms` 갱신으로 바로 사라진다. Windows·브라우저는 `missing` 이 늘 비어 그리지 않는다.
import { useMacPerms } from './useMacPerms';

export function PermissionBanner() {
  const { missing, openSettings, restartApp } = useMacPerms();
  if (missing.length === 0) return null;
  const labels = missing.map((m) => m.label).join('·');
  return (
    <div className="conn-warn perm-banner" role="alert">
      <span>
        ⚠ 이 Mac 은 <b>{labels}</b> 권한이 없어 원격지원을 받을 수 없습니다 — {missing.map((m) => m.effect).join(' · ')}.
      </span>
      <span className="perm-banner-actions">
        {missing.map((m) => (
          <button key={m.kind} onClick={() => openSettings(m.kind)} title={`시스템 설정 > 개인정보 보호 및 보안 > ${m.label}`}>
            {m.label} 설정 열기
          </button>
        ))}
        <button className="ghost" onClick={() => void restartApp()} title="켠 뒤에도 이 띠가 남아 있으면 앱을 다시 시작하세요">
          앱 다시 시작
        </button>
      </span>
    </div>
  );
}
